import React, { FC } from 'react';
import { Stalled, StalledContent } from 'QuoteApp/components';
import { Link } from 'react-router-dom';
import { Button } from '@clearcover/atlas';

export const NotAuthorized: FC = () => {
  return (
    <Stalled testId="aqui-not-authorized-page">
      <StalledContent variant="headline">Not Authorized</StalledContent>
      <StalledContent>
        You or your agency is not authorized to quote in this state. Please
        contact your agency admin to check the status of the agency and agent
        licenses for this state.
      </StalledContent>
      <StalledContent>
        If all licenses for this state are active, please have your agency admin
        contact their Clearcover Account Manager.
      </StalledContent>
      <StalledContent>
        <Link to="/quotes">
          <Button
            data-testid="not-authorized-return-to-portal"
            variant="primary"
          >
            Return to Portal
          </Button>
        </Link>
      </StalledContent>
    </Stalled>
  );
};
